/**
 * @fileoverview The application's TanStack Query client.
 * @description Single QueryClient instance shared by every query/mutation, mounted once via
 * AppProviders. Mutations (like login) don't retry by default so a failed request surfaces
 * immediately instead of silently retrying a bad credential submission. A result counts as fresh
 * for 30 seconds, so moving between pages or back to the tab reuses it instead of fetching the same
 * endpoint again; mutations still refresh what they change by invalidating its query.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, staleTime: 30 * 1000 },
    mutations: { retry: false },
  },
})
